export default __webpack_public_path__ + "static/media/Chave.158b5025.svg";